import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainFooterComponent from "common/components/MainFooterComponent/MainFooterComponent";
import GameHeader from "common/components/GameHeader/GameHeader";
import MainPageHeaderMobile from "common/components/MainPageHeader/MainPageHeaderMobile";
import HeaderFilterCourses from "common/components/HeaderFilterCourses";
import TabsCourses from "features/game/components/TabsCourses";
import { showMobile } from "helpers/adaptation";
import { useTypedDispatch } from "store";
import { getSummaries } from "store/game/thunkActions";
import { BiddingEnum } from "enums/enums";

import "./BySummary.scss";

function BySummary() {
  const dispatch = useTypedDispatch();
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [searchRes, setSearchRes] = useState<any[]>([]);
  const [dataAllCourses, setDataAllCourses] = useState<any>({});
  const [expireModal, setExpireModal] = useState(false);
  const [keyTab, setKeyTab] = useState("summary");
  const takeLevles = useRef(false);

  useEffect(() => {
    const getData = async () => {
      try {
        const res: any = await dispatch(getSummaries());
        const allCourses = res?.Results?.map((item: any) => item.Data) || [];

        const seenNames = new Set();
        const uniqueSummaries = allCourses.filter((course) => {
          if (seenNames.has(course.Name)) {
            return false;
          }
          seenNames.add(course.Name);
          return true;
        });

        const sortedSummaries = uniqueSummaries.sort((a, b) => {
          const aLocked = a.Locked === true ? 1 : 0;
          const bLocked = b.Locked === true ? 1 : 0;
          return aLocked - bLocked;
        });

        const boofer: any = {};
        boofer["summary"] =
          sortedSummaries.length > 0 ? [{ courses: sortedSummaries, Index: 0 }] : [];
        setDataAllCourses(boofer);
      } catch {
        //
      }
    };
    getData();
  }, [dispatch]);

  const onSearch = useCallback(
    (text: string) => {
      setSearch(text);
      if (text === "") {
        return setSearchRes([]);
      }
      const boofer: any[] = [];
      const searchLower = text.toLowerCase();
      const addedNames = new Set();

      Object.values(dataAllCourses).forEach((topic: any) => {
        topic?.forEach((group: any) => {
          group?.courses?.forEach((item: any) => {
            if (
              (item?.Tags?.toLowerCase()?.includes(searchLower) ||
                item?.Name?.toLowerCase()?.includes(searchLower)) &&
              !addedNames.has(item?.Name)
            ) {
              if (item.isEnabled !== false) {
                addedNames.add(item?.Name);
                boofer.push(item);
              }
            }
          });
        });
      });

      boofer.sort((a: any, b: any) => {
        const aLocked = a.Locked === true ? 1 : 0;
        const bLocked = b.Locked === true ? 1 : 0;
        return aLocked - bLocked;
      });

      setSearchRes(boofer);
    },
    [dataAllCourses]
  );

  const onHandleChangeLevel = useCallback(
    (val: any) => {
      const audit: number[] = [];
      if (val?.ease) audit.push(10);
      if (val?.medium) audit.push(20);
      if (val?.hard) audit.push(30);

      const allCoursesUpdated = { ...dataAllCourses };

      Object.keys(allCoursesUpdated).forEach((topicKey) => {
        const topicCourses = allCoursesUpdated[topicKey];
        if (!topicCourses) return;

        allCoursesUpdated[topicKey] = topicCourses.map((group: any) => {
          if (group?.courses?.length) {
            return {
              ...group,
              courses: group.courses.map((item: any) => ({
                ...item,
                isEnabled:
                  audit.length === 0
                    ? true
                    : !!audit.find((level) => `${item?.Levels}`.includes(`${level}`))
              }))
            };
          }
          return group;
        });
      });

      takeLevles.current = true;
      setDataAllCourses(allCoursesUpdated);

      if (search) {
        const filtered: any[] = [];
        const searchLower = search.toLowerCase();
        const addedNames = new Set();

        Object.values(allCoursesUpdated).forEach((topic: any) => {
          topic?.forEach((group: any) => {
            group?.courses?.forEach((item: any) => {
              if (
                item.isEnabled &&
                (item?.Tags?.toLowerCase().includes(searchLower) ||
                  item?.Name?.toLowerCase().includes(searchLower))
              ) {
                if (!addedNames.has(item?.Name)) {
                  addedNames.add(item?.Name);
                  filtered.push(item);
                }
              }
            });
          });
        });

        filtered.sort((a: any, b: any) => {
          const aLocked = a.Locked === true ? 1 : 0;
          const bLocked = b.Locked === true ? 1 : 0;
          return aLocked - bLocked;
        });

        setSearchRes(filtered);
      }
    },
    [dataAllCourses, search]
  );

  useEffect(() => {
    if (Object.keys(dataAllCourses).length > 0 && !takeLevles.current) {
      const resLevels = localStorage.getItem("levels");
      if (resLevels) {
        onHandleChangeLevel(JSON.parse(resLevels));
      } else {
        onHandleChangeLevel({});
      }
    }
  }, [dataAllCourses, onHandleChangeLevel]);

  return (
    <>
      <div className="BySummary-screen-wrapper">
        <div>
          {!showMobile && <GameHeader />}
          {showMobile && <MainPageHeaderMobile showGameMenu />}
          <div className="BySummary-statement-wrapper">
            <HeaderFilterCourses
              title="תקצירים"
              type={BiddingEnum.BIDDING}
              onChangeText={onSearch}
              value={search}
              onHandleChangeLevel={onHandleChangeLevel}
              onExpireModal={() => setExpireModal(true)}
            />
            <div className="BySummary-Tabs-main">
              <div className={search ? "search-mode-active" : ""}>
                <TabsCourses
                  keyTab={keyTab}
                  isExpired={expireModal}
                  onExpiredClose={() => setExpireModal(false)}
                  onSelect={(k: any) => {
                    setKeyTab(k);
                    setSearch("");
                    setSearchRes([]);
                    navigate("/by_summary", { state: { resetModal: Date.now() } });
                  }}
                  dataAllCourses={dataAllCourses}
                  searchRes={searchRes}
                  search={search}
                  type={BiddingEnum.BIDDING}
                  listTitle={{
                    summary: "תקצירים"
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        {!showMobile && <MainFooterComponent />}
      </div>
    </>
  );
}

export default BySummary;
